var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',{staticClass:"mb-4",attrs:{"flush":""}},_vm._l((_vm.requests),function(request,index){return _c('b-list-group-item',{key:'member-' + index,staticClass:"cursor-pointer py-3 px-4",attrs:{"action":""}},[_c('JoinRequest',{attrs:{"request":request}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }